import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";

/** Use the listing aggregate, not the first page of reviews or the APEX score. */
export function ListingReviewLink({
  rating,
  count,
}: {
  rating?: number | null;
  count?: number | null;
}) {
  const { t } = useTranslation();
  if (
    typeof rating !== "number" || !Number.isFinite(rating) || rating < 1 || rating > 5 ||
    typeof count !== "number" || !Number.isInteger(count) || count <= 0
  ) return null;

  return (
    <a
      href="#reviews-section"
      className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-foreground underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
      data-testid="listing-review-link"
    >
      <span className="inline-flex gap-0.5" aria-hidden="true">
        {Array.from({ length: 5 }, (_, index) => (
          <span key={index} className="relative h-4 w-4">
            <Star className="h-4 w-4 text-muted-foreground" />
            <span
              className="absolute inset-y-0 left-0 overflow-hidden text-brand"
              style={{ width: `${Math.max(0, Math.min(1, rating - index)) * 100}%` }}
              data-testid="listing-rating-fill"
            >
              <Star className="h-4 w-4 fill-current" />
            </span>
          </span>
        ))}
      </span>
      <span className="font-semibold">{rating.toFixed(2)}<span className="sr-only"> / 5</span></span>
      <span className="underline">{count} {t(count === 1 ? "common.review" : "common.reviews")}</span>
    </a>
  );
}